import React from "react";
import styled from "styled-components";

import { ISupportTicketTimeTaken } from "src/modules/support/api/support.api";
import { Text } from "src/library/components/Text";
import { minutesToHHMM } from "src/library/utils/time-helpers/time-helpers";

import { SupportTicketTimeTakenListModal } from "./SupportTicketTimeTakenListModal";

export interface TotalSupportTicketTimeTakenProps {
  minutes: number;
  timeTaken: ISupportTicketTimeTaken[];
}

/**
 * Renders a clickable display of total time in hh:mm.
 * The click will open a modal display a breakdown of that total time
 */
const TotalSupportTicketTimeTaken: React.FunctionComponent<TotalSupportTicketTimeTakenProps> = ({ minutes, timeTaken }) => {
  const [ showTimeListModal, setShowTimeListModal ] = React.useState(false);

  return (
    <StyledWrapper>
      <div onClick={() => setShowTimeListModal(true)}>
        <Text>
          {minutesToHHMM(minutes)}
        </Text>
      </div>

      <SupportTicketTimeTakenListModal
        open={showTimeListModal}
        onDismiss={() => setShowTimeListModal(false)}
        timeTaken={timeTaken}
      />
    </StyledWrapper>
  );
};

const StyledWrapper = styled.span`
  &:hover {
    cursor: pointer;
  }
`;

export default TotalSupportTicketTimeTaken;